import storageAvailable from './storageAvailable';

export default storageAvailable;
